import Vue from 'vue';
import dateHelpers from './date-helpers';
import cookieHelpers from './cookie-helpers';
import analyticsHelpers from './analytics-helpers';
import commonHelpers from './common-helpers';
import validationHelpers from './validation-helpers';
import priceHelpers from './price-helpers';
import urlHelpers from './url-helpers';

const helpers = {
  install: (Vue) => {
    Vue.prototype.$helpers = Object.assign({},
      dateHelpers,
      cookieHelpers,
      analyticsHelpers,
      commonHelpers,
      validationHelpers,
      priceHelpers,
      urlHelpers);
  },
};

Vue.use(helpers);
